import {Component, Watch, Vue} from 'vue-property-decorator'
import {
  Collection,
  Dictionary,
  ID,
  PageCollection,
  Resource,
} from 'simpli-web-sdk'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'

@Component
export class MixinSelect extends Vue {
  collection?: PageCollection<Resource> | MotoristaCollection

  /**
   * Used as checkbox models
   */
  selectedResource: Dictionary<boolean> = {}

  /**
   * The result after triggered the selectedResource
   */
  selectedItems: Resource[] = []

  get selectedIds(): ID[] {
    return Object.keys(this.selectedResource)
      .filter(key => this.selectedResource[key])
      .map(id => Number(id))
  }

  get selectedIdsOfPage(): ID[] {
    if (!this.collection) return []
    return this.collection
      .getManyResource(this.selectedIds)
      .map(item => item.$id)
  }

  get allSelectedFromPage(): boolean {
    if (!this.collection || !this.collection.all().length) return false
    return this.selectedIdsOfPage.length === this.collection.all().length
  }

  set allSelectedFromPage(val: boolean) {
    if (!this.collection) return
    for (const item of this.collection.all()) {
      this.selectedResource[item.$id] = val
    }
  }

  @Watch('selectedIdsOfPage', {deep: true})
  selectedIdsOfPageEvent(ids: ID[]) {
    if (!this.collection) return
    for (const item of this.collection.all()) {
      const index = this.selectedItems.findIndex(it => it.$id === item.$id)
      if (index >= 0) {
        this.selectedItems.splice(index, 1)
      }
    }
    this.selectedItems.push(...this.collection.getManyResource(ids))
  }

  @Watch('collection', {deep: true, immediate: true})
  collectionEvent(val: Collection<Resource>) {
    for (const item of val.all()) {
      const value = this.selectedResource[item.$id]
      if (value === undefined) {
        this.$set(this.selectedResource, item.$id, false)
      }
    }
  }
}
